<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      class="form"
      size="small"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group v-model="ruleForm.isApp">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" WEB是否展示：" required>
            <el-radio-group v-model="ruleForm.isWeb">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" 小程序是否展示：" required>
            <el-radio-group v-model="ruleForm.isApplet">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="PC端是否展示：" required>
            <el-radio-group v-model="ruleForm.isPc">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="直播名称：" prop="name">
            <el-input
              placeholder="请输入直播名称"
              v-model="ruleForm.name"
              maxlength="127"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="直播时间：" prop="liveTime" required>
            <DatePicker
              :dateValue="ruleForm.liveTime"
              @dateChange="dateChange"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="直播封面："
            prop="coverUrl"
            :rules="{
              required: true,
              message: '请上传图片',
            }"
            :show-message="showError"
          >
            <div
              v-if="ruleForm.coverUrl"
              class="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="ruleForm.coverUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showAppViewer = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteAppCover"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadAppCover"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleForm.coverUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <!-- <p>APP端轮播图片</p> -->
              <p class="img_tip">建议尺寸：1125*632 px（ 或 16:9 ）；</p>
              <p class="img_tip">图片格式支持PNG,JPG；建议大小不超过2MB</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 讲师 -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲师：" prop="lecturerId" required>
            <load-select 
              class="form-select" 
              v-model="ruleForm.lecturerId" 
              dictLabel="lecturerNameDesc"
              dictValue="uuid" 
              :data="teacherData" 
              :page="teacherPage" 
              :hasMore="teacherMore" 
              :request="getTeacherData"
              placeholder="请选择讲师（输入名称以搜索）" 
              :defaultVal="ruleForm.lecturerNameDesc" 
              :isInit="isTeacherInit"
              @change="teacherChange"
              @ChangeValue="changeValue" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="直播简介：" prop="introduction">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入直播简介"
              v-model="ruleForm.introduction"
              maxlength="1000"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="直播学分要求：" prop="requireTime">
            <div>
              观看直播时长达到
              <el-input-number
                v-model="ruleForm.requireTime"
                :precision="0"
                :max="requireTimeMax"
                :step="1"
                :min="1"
              ></el-input-number>
              分钟及以上，可获得直播学分
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="直播学分：" prop="credit">
            <el-input-number
              v-model="ruleForm.credit"
              :min="0"
              :precision="2"
              :step="0.1"
            ></el-input-number>
            直播结束后第二天结算学分
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item class="scale" label="直播转码：" prop="isTransform">
            <el-radio-group v-model="ruleForm.isTransform">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
            <div>直播转码开启时，会使用咪咕转码服务</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item style="text-align: center">
            <el-button @click="reset">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showAppViewer"
      :on-close="closeAppViewer"
      :url-list="[ruleForm.coverUrl]"
    />
  </div>
</template>

<script>
import { getLecturerParamList } from "@/api/lecturer";
import { liveRoomInfo, saveLiveRoom } from "@/api/liveRoom";
import { getSysParamByTypes } from "@/api/sysParam";
import DatePicker from "@/components/date-picker";
import LoadSelect from "@/components/load-select/index.vue";
import FileHandler from "@/utils/file";
import rulesFactory from "@/utils/rules";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { setItem } from "../../../utils/storage";

export default {
  components: {
    ElImageViewer,
    DatePicker,
    LoadSelect,
  },
  data() {
    return {
      page: 1,
      more: true,
      data: [],
      addTitle: "新增直播",
      ruleForm: {
        name: "",
        liveTime: null,
        coverUrl: "",
        isApplet: 1,
        isApp: 1,
        isWeb: 1,
        isPc: 1,
        credit: "",
        requireTime: undefined,
        introduction: "",
        lecturerId: '',
        lecturerNameDesc: '',
        isTransform: 0,
      },
      rules: {
        name: [
          { required: true, message: "请输入直播名称", trigger: "blur" },
          rulesFactory.size("最多输入127个字", 0, 127),
        ],
        liveTime: [
          {
            required: true,
            message: "请选择直播时间",
            trigger: ["change", "blur"],
          },
        ],
        coverUrl: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
        isTransform: [
          { required: true, message: "请选择直播转码", trigger: "change" },
        ],
        lecturerId: [
          { required: true, message: "请选择讲师", trigger: ["change", "blur"] }],
        introduction: [
          { required: true, message: "请输入直播简介", trigger: "blur" },
          rulesFactory.size("最多输入1000个字", 0, 1000),
        ],
        requireTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              this.checkValue(
                rule,
                value,
                callback,
                "直播要求观看时长需大于0分钟"
              );
            },
            trigger: "blur",
          },
        ],
        credit: [
          { required: true, message: "请录入直播学分", trigger: "blur" },
        ],
      },
      resetForm: {},
      showError: false,
      showCover: false,
      showAppViewer: false,
      editFlag: false,
      publicData: [],
      requireTimeMax: Number.MAX_VALUE,
      teacherPage: 1,
      teacherMore: true,
      teacherData: [],
      isTeacherInit: true,
    };
  },
  created() {
    this.getSysParamByTypes(["IS_VALID"]);
    if (this.$route.query.id) {
      this.addTitle = "编辑直播间";
      this.editFlag = true;
      const id = this.$route.query.id;
      // 处理编辑或者详情
      this.getLiveRoomInfo(id);
    } else {
      this.addTitle = "新增直播间";
      this.editFlag = false;
    }
  },
  methods: {
    goBack() {
      this.$router.push("/liveManage");
    },

    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // this.typeList = res.data["CLIENT_TYPE_BANNER"];
        this.publicData = res.data["IS_VALID"] || [];
        if (!this.$route.query.id) {
          this.ruleForm.isApp = Number(this.publicData[1].paramKey);
          this.ruleForm.isWeb = Number(this.publicData[1].paramKey);
          this.ruleForm.isApplet = Number(this.publicData[1].paramKey);
          this.ruleForm.isPc = Number(this.publicData[1].paramKey);
          this.ruleForm.isTransform = Number(this.publicData[0].paramKey);
        }
      });
    },

    getLiveRoomInfo(id) {
      liveRoomInfo(id).then((res) => {
        if (!res || res.code != 0) return;
        const { data = {} } = res;
        const form = {
          ...data,
          isApp: Number(data.isApp),
          isWeb: Number(data.isWeb),
          isApplet: Number(data.isApplet),
          isPc: Number(data.isPc),
          isTransform: Number(data.isTransform),
          liveTime: [data.startDate, data.endDate],
        }

        this.ruleForm = form;
        this.getRequierMax(form.liveTime);
        this.resetForm = JSON.parse(JSON.stringify(form));
      });
    },

    async uploadAppCover(e) {
      let file = e.file;
      // 上传前检查文件大小，超出3Mb终止上传
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning(`图片大小不能超过2Mb,请重新选择文件`);
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`live/img`, file).then((res) => {
        const { url } = res;
        this.ruleForm.coverUrl = url;
      });
    },
    /**
     * 直播时间变更
     */
    dateChange(val) {
      this.ruleForm.liveTime = val;
      if (val && val.length > 1) {
        const offset = this.getRequierMax(val);
        console.log('----requireTimeMax', this.requireTimeMax, offset);
        // this.ruleForm.requireTime = Math.ceil(offset * 0.8);
        this.ruleForm.requireTime = undefined;
        this.ruleForm.startDate = val[0];
        this.ruleForm.endDate = val[1];
      }
      
    },

    getRequierMax(val) {
      const startDate = new Date(val[0]);
      const endDate = new Date(val[1]);
      const start = startDate.getTime();
      const end = endDate.getTime();
      const offset = (end - start) / 60000; // 计算出分钟
      this.requireTimeMax = offset;
      return offset;
    },

    closeAppViewer() {
      this.showAppViewer = false;
    },

    deleteAppCover() {
      if (this.$refs["coverUpload"] !== undefined) {
        this.$refs["coverUpload"].clearFiles();
      }
      this.ruleForm.coverUrl = "";
    },

    cancel() {
      this.$router.back();
    },

    onSubmit() {
      // if (
      //   this.ruleForm.isApplet == "0" &&
      //   this.ruleForm.isApp == "0" &&
      //   this.ruleForm.isWeb == "0" &&
      //   this.ruleForm.isPc == "0"
      // ) {
      //   this.$message({
      //     message: "请至少选择一个终端展示!",
      //     type: "warning",
      //   });
      //   return;
      // }
      this.$refs["ruleForm"].validate((valid) => {
        if (!this.ruleForm.coverUrl) {
          this.showError = true;
        }

        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let params = { ...this.ruleForm };
              delete params["liveTime"];
              delete params['streamingAddress'];
              delete params['streamingCode'];
              delete params['streamingSumAddress'];
              saveLiveRoom(params, this.editFlag).then((res) => {
                if (!res || res.code != 0) return;
                setItem(this.REFRESH_FLAG, true);
                this.$message.success(res.msg);
                this.goBack();
                this.$refs["ruleForm"].resetFields();
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.editFlag) {
            this.ruleForm = JSON.parse(JSON.stringify(this.resetForm));
          } else {
            Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
          }
        })
        .catch(() => {});
    },

    getTeacherData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getLecturerParamList({ page, lecturerName: keyword }).then(
          ({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.teacherData = [...this.teacherData, ...data.records];
            } else {
              this.teacherData = data.records;
            }
            let { current, total, size } = data;
            this.teacherMore = this.teacherData.length < total;
            this.teacherPage = current;
            resolve();
          }
        ).catch( _ => {
          resolve();
        });
      });
    },

    teacherChange(e) {
      this.isTeacherInit = false;
    },

    changeValue(val) {
      // this.ruleForm.lecturerId = e;
      console.log('-----changeValue---', val);
      let item = this.teacherData.filter((item) => item.uuid == val)[0];
      this.ruleForm.lecturerNameDesc = item.lecturerNameDesc;
    },

    checkValue(rule, value, callback, message) {
      if (!value || value <= 0) {
        callback(new Error(message));
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.download_text {
  color: #3a85ff;
  // text-decoration: none;
}
.el-select__tags-text {
  font-size: 14px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

.video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: left;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 20px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}

.form-select {
  width: 100%;
}
</style>
